import React from 'react';
import { useNavigate } from 'react-router-dom';
import FileUpload from '../components/FileUpload';
import type { FileInfo } from '../types';

const SmartChartUpload: React.FC = () => {
  const navigate = useNavigate();

  const handleUploadSuccess = (fileInfo: FileInfo) => {
    navigate(`/smart-chart/data-select?fileId=${fileInfo.file_id}`);
  };

  return (
    <FileUpload
      onUploadSuccess={handleUploadSuccess}
      title="上传数据，立即洞察。"
      subtitle="上传表格后系统自动识别数据拓扑，推荐最适合的图表类型。"
    />
  );
};

export default SmartChartUpload;
